var map = {
	"./0/Kambi/SecondaryMenu.layout.js": [
		8017,
		89240,
		73879
	],
	"./0/Poker/SecondaryMenu.layout.js": [
		4131,
		89240,
		71006
	],
	"./0/Spectate/SecondaryMenu.layout.js": [
		33790,
		89240,
		46246
	],
	"./1/Kambi/SecondaryMenu.layout.js": [
		21623,
		11450
	],
	"./1/Poker/SecondaryMenu.layout.js": [
		83330,
		89240,
		47147
	],
	"./1/Spectate/SecondaryMenu.layout.js": [
		97680,
		89240,
		2003
	],
	"./31/Kambi/SecondaryMenu.layout.js": [
		38185,
		89240,
		44391
	],
	"./31/Poker/SecondaryMenu.layout.js": [
		38342,
		89240,
		40796
	],
	"./31/Spectate/SecondaryMenu.layout.js": [
		78059,
		89240,
		58068
	],
	"./58/Spectate/SecondaryMenu.layout.js": [
		39885,
		89240,
		22719
	],
	"./75/Kambi/SecondaryMenu.layout.js": [
		66881,
		89240,
		46719
	],
	"./75/Spectate/SecondaryMenu.layout.js": [
		97550,
		89240,
		74724
	],
	"./76/Kambi/SecondaryMenu.layout.js": [
		81061,
		89240,
		79108
	],
	"./76/Spectate/SecondaryMenu.layout.js": [
		5089,
		89240,
		63327
	],
	"./8/Poker/SecondaryMenu.layout.js": [
		23323,
		89240,
		88838
	],
	"./8/Spectate/SecondaryMenu.layout.js": [
		65881,
		89240,
		63800,
		13022
	],
	"./81/Kambi/SecondaryMenu.layout.js": [
		68634,
		89240,
		72522
	],
	"./81/Spectate/SecondaryMenu.layout.js": [
		85447,
		89240,
		51845
	],
	"./84/Kambi/SecondaryMenu.layout.js": [
		45614,
		89240,
		34635
	],
	"./84/Spectate/SecondaryMenu.layout.js": [
		16140,
		89240,
		17484
	],
	"./86/Spectate/SecondaryMenu.layout.js": [
		41529,
		89240,
		25290
	],
	"./87/Spectate/SecondaryMenu.layout.js": [
		88894,
		89240,
		58919
	],
	"./88/Spectate/SecondaryMenu.layout.js": [
		93507,
		89240,
		81288
	],
	"./89/Spectate/SecondaryMenu.layout.js": [
		84560,
		89240,
		37709
	],
	"./90/Spectate/SecondaryMenu.layout.js": [
		27186,
		89240,
		65883
	],
	"./91/Spectate/SecondaryMenu.layout.js": [
		71917,
		89240,
		49774
	],
	"./92/Spectate/SecondaryMenu.layout.js": [
		29860,
		89240,
		87253
	],
	"./94/Spectate/SecondaryMenu.layout.js": [
		58521,
		89240,
		68439
	],
	"./95/Spectate/SecondaryMenu.layout.js": [
		71636,
		89240,
		55738
	],
	"./96/Poker/SecondaryMenu.layout.js": [
		91694,
		89240,
		53545
	],
	"./96/Spectate/SecondaryMenu.layout.js": [
		45780,
		89240,
		63800,
		92593
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76703;
module.exports = webpackAsyncContext;